module.exports = __webpack_public_path__ + "static/media/image-bottom-sheet.440b2af1.webp";